



















import Vue from 'vue'
import Card from '@/components/Layout/Card/Card.vue';
import Select from '@/components/Elements/Select.vue';
import PDFTable from '@/components/Elements/PDFTable.vue';
import PDFViewer from '@/components/Elements/PDFViewer.vue'
import {mapState} from 'vuex';


export default Vue.extend({
  components: {
    Card,
    Select,
    PDFTable,
    PDFViewer
  },
  data: () => ({
    PDFViewerActive: false,
    selected: {},
    customKey: null,
    backendSortingEnabled: false,
    multiColumnSortingEnabled: true,
    sortingPriority: [],
    selectCat: '',
    selectedManualCategory: [],
  }),
  mounted() {
    this.$store.dispatch('ManualStore/pickManual', this.manuals.battery);
  },
  computed: {
    ...mapState('ManualStore', ['manuals', 'selectedManual', 'loading']),
  },
  methods: {
    pickCategory($event) {
      const picked = this.$store.dispatch('ManualStore/pickCategory', $event);
      picked.then(result => {
        switch (result) {
          case 'battery':
            this.$store.dispatch('ManualStore/doLoading', true)
            this.$nextTick(() => {
              this.$store.dispatch('ManualStore/pickManual', this.manuals.battery);
              this.$store.dispatch('ManualStore/doLoading', false)
            })
            break;
          case 'leafBlowers':
            this.$store.dispatch('ManualStore/doLoading', true)
            this.$nextTick(() => {
              this.$store.dispatch('ManualStore/pickManual', this.manuals.leafBlowers);
              this.$store.dispatch('ManualStore/doLoading', false)
            })
            break;
          case 'hedgeSchears':
            this.$store.dispatch('ManualStore/doLoading', true)
            this.$nextTick(() => {
              this.$store.dispatch('ManualStore/pickManual', this.manuals.hedgeSchears);
              this.$store.dispatch('ManualStore/doLoading', false)
            })
            break;
          case 'chainSaws':
            this.$store.dispatch('ManualStore/doLoading', true)
            this.$nextTick(() => {
              this.$store.dispatch('ManualStore/pickManual', this.manuals.chainSaws);
              this.$store.dispatch('ManualStore/doLoading', false)
            })
            break;
          case 'charges':
            this.$store.dispatch('ManualStore/doLoading', true)
            this.$nextTick(() => {
              this.$store.dispatch('ManualStore/pickManual', this.manuals.charges);
              this.$store.dispatch('ManualStore/doLoading', false)
            })
            break;
          case 'mowers':
            this.$store.dispatch('ManualStore/doLoading', true)
            this.$nextTick(() => {
              this.$store.dispatch('ManualStore/pickManual', this.manuals.mowers);
              this.$store.dispatch('ManualStore/doLoading', false)
            })
            break;
          case 'multi-tool':
            this.$store.dispatch('ManualStore/doLoading', true)
            this.$nextTick(() => {
              this.$store.dispatch('ManualStore/pickManual', this.manuals.multiTool);
              this.$store.dispatch('ManualStore/doLoading', false)
            })
            break;
          case 'trimmers':
            this.$store.dispatch('ManualStore/doLoading', true)
            this.$nextTick(() => {
              this.$store.dispatch('ManualStore/pickManual', this.manuals.trimmers);
              this.$store.dispatch('ManualStore/doLoading', false)
            })
            break;
          default:
            this.selectedManualCategory = this.manuals.accus;
        }
      })
    },
    showPDF($event: { id: number; productImage: string; title: string; type: string; accu: string; pdf: string }) {
      this.PDFViewerActive = true;
      this.selected = $event;
    }
  }
})
